import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/components/Reveal";

const faqs = [
  {
    q: "À qui s'adresse ActiPilote ?",
    a: "Aux professionnels des activités touristiques et de loisirs : quad, buggy, jet-ski, location de bateaux, surf, plongée, karting, balades à cheval ou à chameau, excursions, tours et expériences. Si vous gérez des réservations, du matériel et une équipe, ActiPilote est fait pour vous.",
  },
  {
    q: "Puis-je gérer plusieurs établissements ?",
    a: "Oui. ActiPilote est multi-sites : chaque établissement possède ses propres données, vous disposez d'une vue globale pour comparer vos sites, et vous passez instantanément d'un établissement à l'autre depuis la même organisation.",
  },
  {
    q: "Puis-je gérer différents types d'activités ?",
    a: "Oui. La plateforme est conçue de façon générique : une même structure peut gérer plusieurs types d'activités (par exemple quad et excursions) avec leurs formules, leurs équipes et leur flotte dédiées.",
  },
  {
    q: "Mes employés peuvent-ils avoir leurs propres accès ?",
    a: "Oui. Le module Équipe permet d'organiser guides, chauffeurs, réception et collaborateurs, chacun avec ses propres accès à la plateforme.",
  },
  {
    q: "Puis-je suivre mes dépenses et ma caisse ?",
    a: "Oui. Le module Caisse & dépenses suit vos encaissements, vos mouvements de caisse, vos dépenses et leurs justificatifs, directement reliés à votre activité.",
  },
  {
    q: "ActiPilote fonctionne-t-il sur téléphone ?",
    a: "ActiPilote est une application web : elle s'utilise depuis le navigateur de votre ordinateur, de votre tablette ou de votre téléphone, sans installation.",
  },
  {
    q: "Mes données sont-elles séparées de celles des autres entreprises ?",
    a: "Oui. Chaque organisation dispose de ses propres données, strictement isolées de celles des autres entreprises utilisant ActiPilote.",
  },
];

const Faq = () => (
  <section data-testid="faq-section" id="faq" className="scroll-mt-24 bg-white py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <Eyebrow index="08">FAQ</Eyebrow>
        <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
          Questions fréquentes
        </h2>
      </Reveal>
      <Reveal delay={0.15} className="mt-12">
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i}`} className="rounded-2xl border border-slate-200 bg-mist/40 px-6 transition-colors data-[state=open]:border-brand/25 data-[state=open]:bg-white">
              <AccordionTrigger className="py-5 text-left text-sm font-bold text-navy hover:no-underline sm:text-base">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-navy/60">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
